const state = {
  processing: false,
  bulkProcessing: false,
  bonuses: [],
};

export default state;
